export const routes = {
  refurbDiagnosisQuestions: {
    path: "/refurb-diagnosis-questions",
    name: "refurbDiagnosisQuestions",
  },
  refurbQuestionCreate: {
    path: "/refurb-diagnosis-questions/create",
    name: "refurbQuestionCreate",
  },
  refurbQuestionEdit: {
    path: "/refurb-diagnosis-questions/:id/edit/",
    name: "refurbQuestionEdit",
  },
  refurbDiagnosisStart: {
    path: "/refurb-diagnosis/start",
    name: "refurbDiagnosisStart",
  },
  refurbDiagnosisProcessing: {
    path: "/warehouse/refurb-diagnosis/:id",
    name: "refurbDiagnosisProcessing",
  },
  refurbDiagnosisQuestionsProcessing: {
    path: "/refurb-diagnosis/:id/questions",
    name: "refurbDiagnosisQuestionsProcessing",
  },
  refurbDiagnosisSummary: {
    path: "/refurb-diagnosis/:id/summary",
    name: "refurbDiagnosisSummary",
  },
  refurbDiagnosisStock: {
    path: "/refurb-diagnosis/:id/stock",
    name: "refurbDiagnosisStock",
  },
  refurbDiagnosisFinalized: {
    path: "/refurb-diagnosis/:id/finalized",
    name: "refurbDiagnosisFinalized",
  },
};
